import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomModal from '../Modal/CustomModal';
import { customSwal } from '../CustomSwal';
import { getItemType } from './itemTypes';

const EditItemModal = ({ isOpen, onClose, item, dispatch, updateConsoleItem }) => {
  const [itemName, setItemName] = useState('');
  const [draft, setDraft] = useState({});
  // Editors read their value once on mount, so only render them once this item's data is loaded
  const [loadedId, setLoadedId] = useState(null);

  const type = getItemType(item?.itemType);

  // Reload from the saved item on every open so cancelled edits don't linger
  useEffect(() => {
    if (item && isOpen) {
      setItemName(item.displayName || '');
      setDraft(getItemType(item.itemType).fromItem(item));
      setLoadedId(item._id);
    } else if (!isOpen) {
      setLoadedId(null);
    }
  }, [item, isOpen]);

  const updateDraft = (patch) => {
    setDraft((prev) => ({ ...prev, ...(typeof patch === 'function' ? patch(prev) : patch) }));
  };

  const handleSubmit = () => {
    if (!itemName.trim()) {
      customSwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a display name',
      });
      return;
    }

    const error = type.validate(draft, { isNew: false });
    if (error) {
      customSwal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
      });
      return;
    }

    dispatch(updateConsoleItem(item._id, {
      displayName: itemName,
      itemType: item.itemType,
      ...type.toPayload(draft),
    }));
  };

  const { Editor } = type;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Console Item"
      onConfirm={handleSubmit}
      confirmText="Save Changes"
      size="2xl"
    >
      <div className="space-y-4 text-left">
        <div>
          <label className="block mb-1 font-medium">Display Name:</label>
          <p className="mb-2 text-xs text-gray-400">
            Your website looks this item up by name, so renaming it can break the page that uses it.
          </p>
          <input
            type="text"
            className="w-full p-2 rounded bg-gray-700 text-white"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
          />
        </div>

        <p className="flex items-center gap-2 text-sm text-gray-300">
          <FontAwesomeIcon icon={type.icon} className="text-gray-400" />
          {type.label} item
          <span className="text-xs text-gray-500">(the type can't be changed)</span>
        </p>

        {item && loadedId === item._id && (
          <Editor draft={draft} onChange={updateDraft} consoleId={item.associatedConsole} />
        )}
      </div>
    </CustomModal>
  );
};

export default EditItemModal;
